export const GET_CARRIER_LIST_REQUEST = "GET_CARRIER_LIST_REQUEST";
export const GET_CARRIER_LIST_SUCCESS = "GET_CARRIER_LIST_SUCCESS";
export const GET_CARRIER_LIST_FAILURE = "GET_CARRIER_LIST_FAILURE";
export const GET_CARRIER_LIST_RESET = "GET_CARRIER_LIST_RESET";
export const getCarrierListRequest = (payload) => ({
    type: GET_CARRIER_LIST_REQUEST,
    payload,
});
export const getCarrierListSuccess = (payload) => ({
    type: GET_CARRIER_LIST_SUCCESS,
    payload,
});
export const getCarrierListFailure = (payload) => ({
    type: GET_CARRIER_LIST_FAILURE,
    payload,
});
export const getCarrierListReset = () => ({
    type: GET_CARRIER_LIST_RESET,
});
